import { JobState } from '@treadinc/horizon-api-spec';

import { spacing } from '~theme/AppTheme';

export const ORDERS_LIST_CONTAINER_VERTICAL_GAP = spacing(1.5);
export const ORDERS_LIST_GAP = spacing(1.5);
export const FILES_QUERY_CONTEXT_PREFIX = 'FilesQueryContextProvider';
export const JOBS_QUERY_CONTEXT_PREFIX = 'JobsQueryContextProvider';

export enum FilesQueryOrdersSort {
  ACCOUNT_NAME = 'account_name',
  COMPANY_LEGAL_NAME = 'company_legal_name',
  CREATED_AT = 'created_at',
  DISPATCH_NUMBER_NAME = 'dispatch_number',
  FRIENDLY_ORDER_ID = 'friendly_order_id',
  LOAD_AT = 'load_at',
}

export const DEFAULT_INCLUDED_JOB_STATES = [
  JobState.COMPLETED,
  JobState.ENDED,
  JobState.IN_REVIEW,
];

export const EXCLUDED_JOB_STATES = [JobState.REJECTED];

export const APPROVALS_JOB_STATES = Object.values(JobState).filter(
  (state) => !EXCLUDED_JOB_STATES.includes(state),
);
